<div class="autosave">
  <div class="spinner" *ngIf="saving">
    <spinner2></spinner2>
  </div>
  <span  [@fade] class="success" *ngIf="isCompleted && saved"> Saved </span>
  <span  [@fade] class="fail" *ngIf="isCompleted && !saved"> Not saved </span>
</div>